import { render, staticRenderFns, recyclableRender, components } from "./jp-signature-popup.vue?vue&type=template&id=1756e4df&scoped=true&"
var renderjs
import script from "./jp-signature-popup.vue?vue&type=script&lang=js&"
export * from "./jp-signature-popup.vue?vue&type=script&lang=js&"
import style0 from "./jp-signature-popup.vue?vue&type=style&index=0&id=1756e4df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756e4df",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/jp-signature/components/jp-signature-popup/jp-signature-popup.vue"
export default component.exports